import { render, staticRenderFns } from "./AgingDialog.vue?vue&type=template&id=b90ec8bc&"
import script from "./AgingDialog.vue?vue&type=script&lang=js&"
export * from "./AgingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports